export default __webpack_public_path__ + "static/media/TIBIA_SAGITAL_RIGHT.99b8ceac.jpg";